import React from "react";
import { MdAdd } from "react-icons/md";

interface EmptyTabStateProps {
  message: string;
  buttonLabel: string;
  onAdd: () => void;
}

const EmptyTabState: React.FC<EmptyTabStateProps> = ({
  message,
  buttonLabel,
  onAdd,
}) => (
  <button
    type="button"
    onClick={onAdd}
    className="flex w-full flex-col items-center gap-2 rounded-md border border-dashed border-gray-300 py-6 text-center transition-colors duration-200 hover:border-biafit-primary hover:bg-biafit-primary/5 dark:border-gray-600 dark:hover:border-biafit-primary"
  >
    <span className="text-sm text-gray-400 dark:text-gray-500">{message}</span>
    <span className="inline-flex items-center text-sm font-medium text-biafit-primary">
      <MdAdd className="mr-1 h-4 w-4" />
      {buttonLabel}
    </span>
  </button>
);

export default EmptyTabState;
